<template>
  <ul class="rt-notice-center">
    <ul class="notice-main">
      <li
        v-for="item in noticeList.slice(0, 100)"
        :key="item.id"
      >
        <rt-icon
          :name="`rt-base-${item.icon}`"
          size="14"
          :class="item.icon"
        />
        <span class="notice-text">{{ item.text }}</span>
      </li>
    </ul>
    <li
      v-if="showViewAll"
      class="look-all"
    >
      <span @click="onViewAll">{{ $tx('查看全部', 'xpc.common.showAll') }}</span>
    </li>
  </ul>
</template>

<script>
import RtIcon from '../icon/rtIcon.vue';
export default {
  name: 'RtNoticeCenter',
  components: { RtIcon },
  props: {
    noticeList: {
      type: Array
    },
    showViewAll: {
      type: Boolean,
      default: true
    },
    href: {
      type: String,
      default: ''
    }
  },
  methods: {
    onViewAll () {
      this.$router.push(this.href);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtNoticecenter.vue?2a0e0b15